import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Mail, Phone, Inbox } from "lucide-react";
import { api, apiErr, labelCls } from "./adminShared";

const STATUSES = [["new", "New"], ["contacted", "Contacted"], ["quote_sent", "Quote Sent"], ["booked", "Booked"], ["closed", "Closed"]];
const STATUS_STYLE = { new: "bg-amber-100 text-amber-800", contacted: "bg-blue-100 text-blue-800", quote_sent: "bg-purple-100 text-purple-800", booked: "bg-green-100 text-green-800", closed: "bg-gray-100 text-gray-600" };

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [filter, setFilter] = useState("all");
  const load = () => api.get("/admin/inquiries").then((r) => setLeads(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const setStatus = async (l, status) => {
    try { await api.patch(`/admin/inquiries/${l.inquiry_id}`, { status }); toast.success("Status updated"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  const shown = filter === "all" ? leads : leads.filter((l) => (filter === "future" ? l.area_status === "future_service_area" : l.status === filter));

  return (
    <div className="space-y-4" data-testid="admin-leads">
      <div className="flex flex-wrap gap-2">
        {[["all", "All"], ...STATUSES, ["future", "Future Service Area"]].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)} className={`text-xs rounded-full px-3 py-1.5 border ${filter === v ? "bg-[#2C2621] text-white border-[#2C2621]" : "border-[#E6DEC3] text-[#635B52]"}`} data-testid={`lead-filter-${v}`}>{l}</button>
        ))}
      </div>

      <div className="space-y-2">
        {shown.map((l) => (
          <div key={l.inquiry_id} className="bg-white border border-[#E6DEC3] rounded-xl p-4 text-sm" data-testid={`lead-${l.inquiry_id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-semibold text-[#2C2621]">{l.first_name}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_STYLE[l.status] || "bg-gray-100"}`}>{STATUSES.find(([v]) => v === l.status)?.[1] || l.status}</span>
                  {l.area_status === "future_service_area" && <span className="text-xs px-2 py-0.5 rounded-full bg-orange-100 text-orange-700">Future Service Area</span>}
                  {l.marketing_consent && <span className="text-xs px-2 py-0.5 rounded-full bg-[#B87333]/15 text-[#B87333]">Marketing opt-in</span>}
                </div>
                <div className="mt-1.5 text-[#635B52] flex flex-wrap gap-x-4 gap-y-1">
                  <span className="inline-flex items-center gap-1"><Mail size={13} /> {l.email}</span>
                  {l.phone && <span className="inline-flex items-center gap-1"><Phone size={13} /> {l.phone}</span>}
                  <span className="inline-flex items-center gap-1"><MapPin size={13} /> {l.zip}</span>
                </div>
                <p className="mt-1 text-[#2C2621]">{l.service_label} · {l.timeframe}</p>
                {l.message && <p className="mt-1 text-[#635B52] italic">"{l.message}"</p>}
                <p className="mt-1 text-xs text-[#635B52]">{l.source} · {new Date(l.submitted_at).toLocaleString()}</p>
              </div>
              <select value={l.status} onChange={(e) => setStatus(l, e.target.value)} className="rounded-lg border border-[#E6DEC3] px-2 py-1.5 text-sm shrink-0" data-testid={`lead-status-${l.inquiry_id}`}>
                {STATUSES.map(([v, lb]) => <option key={v} value={v}>{lb}</option>)}
              </select>
            </div>
          </div>
        ))}
        {!shown.length && <div className="bg-white border border-[#E6DEC3] rounded-xl p-10 text-center text-[#635B52]"><Inbox className="mx-auto mb-2" size={28} /> No leads yet.</div>}
      </div>
    </div>
  );
}
